import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb } from 'semantic-ui-react'

import { trackingPath } from 'routes'
import TrackingItem from '../Shareds/TrackingItem'
import RequestInfo from '../Shareds/RequestInfo'
import { StdCard } from 'components'
import { 
  MainBodyContent, 
} from 'components'
import { 
  initializeTracking,
  getTrackingDetail,
} from 'ducks/tracking'
import { 
  purchaseRequisitionDetailPath,
  requestForQuotationDetailPath,
  purchaseOrderDetailPath,
  purchaseOrderUpdateDetailPath,
  contractDetailPath,
  downPaymentDetailPath,
  goodsServiceReceiptDetailPath,
  BillformDetailPath
} from 'routes'
import r from 'reactotron-react-js'

const DetailTracking = props => {

  const { 
    history,
    trackingDetail,
  } = props

  const [collapse, setCollapse] = React.useState({})

  React.useEffect(() => {
    const { match } = props
    window.scrollTo(0,0)
    props.initializeTracking()
    if (match && match.params && match.params.tkId) {
      if(!Object.keys(trackingDetail).length){
        props.getTrackingDetail(match.params.tkId, history)
      }
    }
  },[])

  const onCollapse = (index) =>{
    let clone = JSON.parse(JSON.stringify(collapse))
    clone[index] = collapse[index]!=undefined?!collapse[index]:false
    setCollapse(clone)
  }

  return (
    <MainBodyContent
      headerTitle={<React.Fragment>{`Tracking PR ${trackingDetail?trackingDetail.documentNumber?`- #${trackingDetail.documentNumber}`:'':''}`}</React.Fragment>}
      breadcrumbs={
        <Breadcrumb
          icon="right angle"
          sections={[
            {
              key: 'pou',
              content: 'Tracking',
              link: true,
              onClick: () => history.push(trackingPath),
            },
            { key: 'trackingDetail', content: 'Detail', active: true },
          ]}
        />
      }
    >
      <RequestInfo/>
      <div style={{height:'1rem'}}/>
      {Object.keys(trackingDetail).length>0?
        <StdCard title="Tracking">
          <div style={{marginTop:'1rem', marginLeft:'2rem'}}>
            <TrackingItem icon='clipboard' title='Purchasing Requisition (PR)' data={trackingDetail.detail.pr} redirect={purchaseRequisitionDetailPath} activeCollapse={collapse[0]} onCollapse={()=>onCollapse(0)}/>
            <TrackingItem icon='clipboard list' title='Request for Quotation(RFQ)' data={trackingDetail.detail.rfq} redirect={requestForQuotationDetailPath} activeCollapse={collapse[1]} onCollapse={()=>onCollapse(1)}/>
            <TrackingItem icon='clipboard list' title='Purchase Order(PO)' data={trackingDetail.detail.po} redirect={purchaseOrderDetailPath} activeCollapse={collapse[2]} onCollapse={()=>onCollapse(2)}/>
            <TrackingItem icon='clipboard list' title=' Update/Cancel PO' data={trackingDetail.detail.poUpdate} redirect={purchaseOrderUpdateDetailPath} activeCollapse={collapse[3]} onCollapse={()=>onCollapse(3)}/>
            <TrackingItem icon='dollar sign' title='Down Payment(DP)' data={trackingDetail.detail.dp} redirect={downPaymentDetailPath} activeCollapse={collapse[4]} onCollapse={()=>onCollapse(4)}/>
            <TrackingItem icon='gavel' title='Contract' data={trackingDetail.detail.contract} redirect={contractDetailPath} activeCollapse={collapse[5]} onCollapse={()=>onCollapse(5)}/>
            <TrackingItem icon='dolly flatbed' title='Goods/Service Receipt (GR)' data={trackingDetail.detail.gr} redirect={goodsServiceReceiptDetailPath} activeCollapse={collapse[6]} onCollapse={()=>onCollapse(6)}/>
            <TrackingItem icon='clipboard check' title='Billing' data={trackingDetail.detail.bl} redirect={BillformDetailPath} activeCollapse={collapse[7]} onCollapse={()=>onCollapse(7)}/>
            {/* <TrackingItem icon='dollar sign' title='Payment' data={trackingDetail.detail.pay} isLast redirect={BillformDetailPath} activeCollapse={collapse[8]} onCollapse={()=>onCollapse(8)}/> */}
          </div>
        </StdCard>
        :
        null
      }
    </MainBodyContent>
  )

}

const mapStateToProps = (state) => {
  let trackingDetail = state.tracking.trackingDetail
  return ({
    initialValues: {
      ...trackingDetail.data,
    },
    trackingDetail: trackingDetail.data,
  })
}
const mapDispatchToProps = {
  initializeTracking,
  getTrackingDetail,
}

const contForm = reduxForm({
  form: 'formTracking',
  enableReinitialize: true,
})(DetailTracking)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
